import React, { createContext } from "react";

type FlagContextType = {
  groupsMachinesReFetchFlag: boolean;
  setGroupsMachinesReFetchFlag: React.Dispatch<React.SetStateAction<boolean>>;
};
const initialState = {
  groupsMachinesReFetchFlag: true,
  setGroupsMachinesReFetchFlag: () => null,
};
const GroupsMachinesReFetchFlagContext = createContext<FlagContextType>(initialState);

export default GroupsMachinesReFetchFlagContext;
